module.exports = __webpack_public_path__ + "static/media/Logo_Grupo_Soma_branco.0188e004.svg";